import { useDispatch, useSelector } from "react-redux";

import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import loadConfig, {
  getApiClient,
  initializeApiClient,
} from "../../Services/apiService";
import TableAHSF from "../../Components/TableAHSF";
import PopupAHSF from "../../Components/PopupAHSF";
import { setRefreshTable } from "../../Redux/Reducers/VariousVariables";
import AddEditEventsActivitiesNextFlow from "./AddEditEventsActivitiesNextFlow";

const EventsActivitiesNextFlow = (props) => {
  const dispatch = useDispatch();
  const [jsonData, setJsonData] = useState({});
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const [popUpBodyOPjectDataStatus, setPopUpBodyOPjectDataStatus] =
    useState(false);
  const [popUpBodyOPjectDataAddStatus, setpopUpBodyOPjectDataAddStatus] =
    useState(false);
  const [EventsActivitiesNextFlowId, setEventsActivitiesNextFlowId] =
    useState(null);
  const state = useSelector((state) => {
    return {
      //   ApplicationInformation:
      //     state.ApplicationInformation.ApplicationInformation,
      jsonData: state.FetchDataJson.JsonData,
      //   TeamMembersPreviousExperiencePartnerships:
      //     state.TeamMembersPreviousExperiencePartnerships
      //       ?.TeamMembersPreviousExperiencePartnerships,
      //   ActiveRound: state.ApplicationInformation.ActiveRound,
    };
  });

  //   const shouldDisableFields = !(

  //     (
  //       state.ActiveRound == state.ApplicationInformation?.aI_RoundYearId &&
  //       state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
  //       window.location.href.includes("manager") == false
  //     )
  //   );
  const RequestAccessor = [
    {
      KeyName: "activityName",
      ShowStatus: true,
      NmaeColumn: "اسم النشاط",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "nationalityAr",
      ShowStatus: true,
      NmaeColumn: "البلد",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "cityNAmeAr",
      ShowStatus: true,
      NmaeColumn: "المحافظة",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "typeOfActivityNAme",
      ShowStatus: true,
      NmaeColumn: "نوع النشاط",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "durationDays",
      ShowStatus: true,
      NmaeColumn: "المدة الزمنية للنشاط بالايام	",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "activityStartDate",
      ShowStatus: true,
      NmaeColumn: "تاريخ النشاط (من)",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "activityEndDate",
      ShowStatus: true,
      NmaeColumn: "تاريخ النشاط (الى) ",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "ageGroupName",
      ShowStatus: true,
      NmaeColumn: " تحديد الفئة العمرية ",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];
  const M_ApplicationsBtns = [
    {
      Click: async (e) => {
        //console.log(e.target.value, "sssssssssssss");

        setEventsActivitiesNextFlowId(e.target.value);
        setPopUpBodyOPjectDataStatus(true);
      },
      content: "",
        className: props.canEdit
          ? "bi bi-pencil-square"
          : "bi bi-view-list",
      // className: "bi bi-pencil-square",

      id: "editBtn",
      title: "عرض",
      ShowStatus: true,
    },
    {
      Click: async (e) => {
        Swal.fire({
          title: state.jsonData.deleteTitlePopUp?.nameAR,
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "الغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then(async (res) => {
          if (res.isConfirmed == true) {
            await initializeApiClient();
            const apiClient = await getApiClient();
            const response = await apiClient.post(
              "api/PR_EventsActivitiesNextFlow/DeletePR_EventsActivitiesNextFlowData",
              {
                pR_EventsActivitiesNextFlowGUID: e.target.value,
              }
            );
            Swal.fire({
              position: "center",
              icon: "success",
              title: "تم الحذف بنجاح",
              showConfirmButton: false,
              timer: 1500,
              // width: "500px",
            });
            dispatch(setRefreshTable());
          }
        });
      },
      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "حذف",
      // ShowStatus: !shouldDisableFields,
      ShowStatus: props.canEdit,
    },
  ];

  const getJson = async () => {
    var json = await loadConfig();
    // //console.log(json,"malwk");

    setJsonData(json);
  };
  useEffect(() => {
    setJsonData(getJson());
  }, []);

  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},
    componentBody: <div>{<AddEditEventsActivitiesNextFlow />}</div>,
    title:
      " تحديد أهم الفعاليات / الأنشطة التي تم سيتم  تنفيذها خلال المرحلة التالية",
    maxWidth: "500px",
    maxHeight: "500px",
  };

  const closePopUpBodyOPjectData = () => {
    setPopUpBodyOPjectDataStatus(false);
  };

  const popUpBodyOPjectData = {
    isPopupOpenStatus: popUpBodyOPjectDataStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyOPjectDataStatus(false);
    },
    componentBody: (
      <div>
        <AddEditEventsActivitiesNextFlow
          pR_EventsActivitiesNextFlowGUID={EventsActivitiesNextFlowId}
          canEdit="edit"
          shouldDisableFields={!props.canEdit}

        />
      </div>
    ),
    title:
      "تحديد أهم الفعاليات / الأنشطة التي تم سيتم  تنفيذها خلال المرحلة التالية",
    maxWidth: "500px",
    maxHeight: "500px",
  };

  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"pR_EventsActivitiesNextFlowGUID"}
        valueButtonAction={"pR_EventsActivitiesNextFlowGUID"}
        URL={`api/PR_EventsActivitiesNextFlow/GetPR_EventsActivitiesNextFlowListData`}
        UrlBody={{
          specificOrMulti: true,
          stageGuid: props.pR_ReportsStagesGuid,
          reportGuid: props.reportId,
          applicationInfoGuid: "string",
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={
          " تحديد أهم الفعاليات / الأنشطة التي تم سيتم  تنفيذها خلال المرحلة التالية "
        }
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        // tableBtn={!shouldDisableFields}
        tableBtn={props.canEdit}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={M_ApplicationsBtns}
        ArrayNameDataColum={[]}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            isPopupOpenStatus={popUpBodyOPjectData.isPopupOpenStatus}
            isPopupOpenFunction={popUpBodyOPjectData.isPopupOpenFunction}
            title={popUpBodyOPjectData.title}
            componentBody={popUpBodyOPjectData.componentBody}
            maxWidth={popUpBodyOPjectData.maxWidth}
            maxHeight={popUpBodyOPjectData.maxHeight}
          />
        }
      />
    </>
  );
};

export default EventsActivitiesNextFlow;
